import React, { useState, useEffect, useRef } from 'react';
import './CallToAction.scss';

const CallToAction = ({ onSignUpClick, ctaRef }) => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const element = sectionRef.current;
    if (!element) return;

    /*
     * Bidirectional IntersectionObserver — NO unobserve.
     * Fires on BOTH enter (isIntersecting: true → visible) and
     * exit (isIntersecting: false → invisible + animates out).
     * The CTA section enters the viewport naturally near the end of
     * AppPromo scroll due to the negative-margin straddle layout.
     */
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((entry) => setVisible(entry.isIntersecting)),
      { threshold: 0.15 }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={(el) => {
        sectionRef.current = el;
        if (ctaRef) ctaRef.current = el;
      }}
      className="cta-section"
    >
      <div className="container">
        <div className={`cta-section__inner${visible ? ' visible' : ''}`}>
          <h2 className="cta-section__title">
            Ready to Modernize Heavy Hauling in{' '}
            <span className="cta-section__title-highlight">Ontario?</span>
          </h2>

          <p className="cta-section__subtitle">
            Have questions about posting jobs, managing drivers, or automating
            your invoicing process?
            <br />
            We&rsquo;re here to help.
          </p>

          <div className="cta-section__buttons">
            <button
              type="button"
              className="cta-section__btn cta-section__btn--filled"
              onClick={() => onSignUpClick('cc')}
            >
              CONTRACTOR / SIGN UP
            </button>
            <button
              type="button"
              className="cta-section__btn cta-section__btn--outlined"
              onClick={() => onSignUpClick('tc')}
            >
              CARRIER / SIGN UP
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
